<template>
  <div class="pt-editor-help__sp-create">
    <div class="pt-editor-help__tips">
      <div class="pt-editor-help__block">
        <b>ЛКМ</b> - выбор местоположения и создание объектов
      </div>
    </div>
    <div class="pt-editor-help__image-block">
      <img
        v-if="theme === 'dark-theme'"
        class="pt-editor-help__image"
        src="../../../../../assets/images/public-transport/stop_points_create_dark.gif"
      />
      <img
        v-else
        class="pt-editor-help__image"
        src="../../../../../assets/images/public-transport/stop_points_create_light.gif"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ["theme"]
};
</script>

<style></style>
